import { useState } from "react";
import { CreateUserForm } from "../../CreateUser/components/CreateUserForm"; 
import { UsuariosList } from "../../UserList/components";
import { UserDetails } from "../../UserDetails/components/UserDetails";
import { useAdminPanelUI } from "../../../../hooks/useAdminPanelUI";

export function UserActionsContainer() {
    const [userSelectedId, setUserSelectedId] = useState(0);

    const { userActions } = useAdminPanelUI();

    const actions = {
        "UserList": <UsuariosList 
            setUserSelected={setUserSelectedId} />,
        "UserCreateForm": <CreateUserForm />,
        "UserDetails": <UserDetails
            userId={userSelectedId} />
    }

    const currentAction = actions[userActions];

    return (
        <div className="h-full w-full">
            {currentAction}
        </div>
    );
}
